import type { QualityDashboardResponse } from "@ailan/contracts";

export function createQualityDemoDashboard(date: string): QualityDashboardResponse {
  const at = (time: string) => new Date(`${date}T${time}:00+08:00`).toISOString();
  const sessions: QualityDashboardResponse["sessions"] = [
    {
      id: "demo-quality-session-001",
      sourceConversationId: "模拟-TM-QA-001",
      platform: "tmall",
      storeName: "爱兰歌娜旗舰店",
      agentName: "郑佳婷",
      customerName: "模拟顾客A",
      orderId: "DEMO-TM-202607240001",
      yellowFlagged: true,
      startedAt: at("09:02"),
      endedAt: at("09:08"),
      collectedAt: at("09:10"),
      score: 52,
      status: "PENDING",
      summary: "客户询问产品使用方式和适用人群，客服回复态度不当且未完成跟进",
      source: "DEMO_REFERENCE",
      messages: [
        { id: "demo-TM-QA-001-1", sender: "CUSTOMER", sentAt: at("09:02"), content: "这个产品敏感肌可以用吗？", flagged: false },
        { id: "demo-TM-QA-001-2", sender: "AGENT", sentAt: at("09:05"), content: "详情页写得很清楚，您自己看一下就行。", flagged: true },
        { id: "demo-TM-QA-001-3", sender: "CUSTOMER", sentAt: at("09:08"), content: "我就是没找到才来问的，能具体说一下吗？", flagged: true },
      ],
      issues: [
        { id: "demo-issue-001", type: "ATTITUDE", severity: "HIGH", title: "服务态度不当", reason: "回复带有推诿和不耐烦语气，没有正面回应客户诉求。", evidence: "详情页写得很清楚，您自己看一下就行。", suggestion: "先确认客户肤质和使用场景，再明确说明适用条件与注意事项。", messageId: "demo-TM-QA-001-2" },
        { id: "demo-issue-002", type: "NO_REPLY", severity: "HIGH", title: "客户消息未回复", reason: "客户追问后会话结束，诉求没有闭环。", evidence: "我就是没找到才来问的，能具体说一下吗？", suggestion: "将未回复会话加入提醒队列，离线前完成回复或转交。", messageId: "demo-TM-QA-001-3" },
      ],
    },
    {
      id: "demo-quality-session-002",
      sourceConversationId: "模拟-DY-QA-002",
      platform: "douyin",
      storeName: "Algn爱兰歌娜生活旗舰店",
      agentName: "殷筱婷",
      customerName: "模拟顾客B",
      orderId: "DEMO-DY-202607240002",
      yellowFlagged: false,
      startedAt: at("10:21"),
      endedAt: at("10:27"),
      collectedAt: at("10:30"),
      score: 34,
      status: "CORRECTING",
      summary: "客户咨询发货时间，会话存在响应慢、答非所问和漏插黄色旗子",
      source: "DEMO_REFERENCE",
      messages: [
        { id: "demo-DY-QA-002-1", sender: "CUSTOMER", sentAt: at("10:21"), content: "我的订单今天能发货吗？", flagged: true },
        { id: "demo-DY-QA-002-2", sender: "AGENT", sentAt: at("10:24"), content: "亲，稍等。", flagged: true },
        { id: "demo-DY-QA-002-3", sender: "AGENT", sentAt: at("10:25"), content: "亲亲麻烦您按照图片操作截图过来给您优先退5哦", flagged: true },
        { id: "demo-DY-QA-002-4", sender: "AGENT", sentAt: at("10:27"), content: "已经为您核实，预计今天18点前出库。", flagged: false },
      ],
      issues: [
        { id: "demo-issue-003", type: "SLOW_REPLY", severity: "MEDIUM", title: "响应时间过长", reason: "客户等待超过120秒才收到首次回复。", evidence: "我的订单今天能发货吗？", suggestion: "高峰期先发送包含预计等待时间的有效首响，再完成订单核实。", messageId: "demo-DY-QA-002-1" },
        { id: "demo-issue-004", type: "IRRELEVANT_REPLY", severity: "MEDIUM", title: "回复未解决问题", reason: "首次回复没有回应发货时间，也没有给出预计核实时长。", evidence: "亲，稍等。", suggestion: "说明正在核实发货状态，并承诺具体反馈时间。", messageId: "demo-DY-QA-002-2" },
        { id: "demo-issue-005", type: "MISSING_YELLOW_FLAG", severity: "HIGH", title: "漏插黄色旗子", reason: "会话中出现指定的好评或返现关键词，但对应订单明确未插颜色旗子。", evidence: "亲亲麻烦您按照图片操作截图过来给您优先退5哦", suggestion: "立即核对订单并补插黄色旗子，检查返现与退款记录。", messageId: "demo-DY-QA-002-3" },
      ],
    },
    {
      id: "demo-quality-session-003",
      sourceConversationId: "模拟-PDD-QA-003",
      platform: "pdd",
      storeName: "爱兰歌娜官方旗舰店",
      agentName: "冉佳欣",
      customerName: "模拟顾客C",
      orderId: "DEMO-PDD-202607240003",
      yellowFlagged: null,
      startedAt: at("13:15"),
      endedAt: at("13:18"),
      collectedAt: at("13:20"),
      score: 100,
      status: "COMPLETED",
      summary: "客户咨询退款到账时间，客服及时给出清晰答复",
      source: "DEMO_REFERENCE",
      messages: [
        { id: "demo-PDD-QA-003-1", sender: "CUSTOMER", sentAt: at("13:15"), content: "退款审核通过后多久能到账？", flagged: false },
        { id: "demo-PDD-QA-003-2", sender: "AGENT", sentAt: at("13:15"), content: "审核通过后通常1至3个工作日原路退回，我也会继续帮您留意进度。", flagged: false },
      ],
      issues: [],
    },
  ];

  const agents = [...new Set(sessions.map((session) => session.agentName))].map((agentName) => {
    const records = sessions.filter((session) => session.agentName === agentName);
    return {
      agentName,
      sessionCount: records.length,
      issueSessionCount: records.filter((record) => record.issues.length > 0).length,
      averageScore: records.reduce((sum, record) => sum + record.score, 0) / records.length,
      mainIssue: records.flatMap((record) => record.issues.map((item) => item.title))[0] ?? null,
      captureStatus: "CAPTURED" as const,
    };
  });

  return {
    date,
    summary: {
      sessionCount: sessions.length,
      issueSessionCount: sessions.filter((session) => session.issues.length > 0).length,
      noReplyCount: sessions.filter((session) => session.issues.some((item) => item.type === "NO_REPLY")).length,
      attitudeCount: sessions.filter((session) => session.issues.some((item) => item.type === "ATTITUDE")).length,
      missingYellowFlagCount: sessions.filter((session) => session.issues.some((item) => item.type === "MISSING_YELLOW_FLAG")).length,
      agentCount: agents.length,
    },
    agents,
    sessions,
  };
}
